import { RAI_SSO_SERVICE_URL } from "../definitions.js"
import { apiCall, responseValidation } from "../utils.js"
import { GenericResponse, RegistrationRequest, RegistrationResponse } from "./service-models.js"
import { genericResponseSchema, registrationResponseSchema } from "./utils.js"
import { RaissoError, errorFactory } from "../responses.js"
import { R } from "@mobily/ts-belt"

const BASE_URL = `${RAI_SSO_SERVICE_URL}`

function traceError(e: unknown) {
  console.error('[registration-controller] Error:', e)
}

class RegistrationController {
  private constructor() {/* empty */}

  private static _instance: RegistrationController;
  public static get instance(): RegistrationController {
    if (!this._instance) {
      this._instance = new RegistrationController()
    }
    return this._instance;
  }

  public async registration(data: RegistrationRequest) {
    const url = `${BASE_URL}/registration`
    try {
      const response = await apiCall<RegistrationResponse>(url, 'json', 'POST', { 'content-type': 'application/json' }, JSON.stringify(data))
      const value = R.map(response, responseValidation(registrationResponseSchema))
      return value
    } catch (e) {
      traceError(e)
      return R.Error<RaissoError>(errorFactory(
        RaissoError,
        (e instanceof Error) ? e.message : 'Opps! Qualcosa è andato storto',
        { cause: e, context: { request: { url, body: JSON.stringify(data) } } }
      ))
    }
  }

  public async resendActivationMail(email: string, domainApiKey: string) {
    let url = `${BASE_URL}/user/resendActivation`
    const u = new URL(url, window.location.origin)
    u.searchParams.set('email', email);
    u.searchParams.set('domainApiKey', domainApiKey);
    url = u.href;
    try {
      const response = await apiCall<GenericResponse>(url, 'json', 'GET')
      const value = R.map(response, responseValidation(genericResponseSchema))
      return value
    } catch (e) {
      traceError(e)
      return R.Error<RaissoError>(errorFactory(
        RaissoError,
        (e instanceof Error) ? e.message : 'Opps! Qualcosa è andato storto',
        { cause: e, context: { request: { url, } } }
      ))
    }
  }
}

export default RegistrationController;
